import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=1bad1169&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"
import style1 from "./gift.vue?vue&type=style&index=1&id=1bad1169&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad1169",
  null
  
)

export default component.exports